<template>
  <v-app>
    <app-header />
    <router-view class="pb-12 mb-12" />
    <app-footer />
  </v-app>
</template>

<script>
import appFooter from '@/components/app-footer.vue';
import appHeader from '@/components/app-header.vue';

export default {
  name: 'App',

  components: {
    appHeader,
    appFooter,
  },
};
</script>
